// eslint-disable-next-line import/prefer-default-export
export const DAYS_BETWEEN_DEFAULT_INTERVAL = 30
